/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import PropTypes from 'prop-types'
import Link from 'components/link'
import Card from 'components/card'
import QuantityInformation from './quantity-information'
import EditRegItemLink from './edit-reg-item-link'
import { regItemProps } from './reg-item-props'
import RegItemCardLayout from './reg-item-card-layout'
import OwnerActions from './owner-actions/owner-actions'
import NotReservedAction from './guest-actions/not-reserved-action'
import { ReservationStatusAction } from './guest-actions/reservation-status-action'
import AddOrBuy from 'registry/components/add-or-buy/add-or-buy'

export const FavorRegItemCard = (
  {
    regItem,
    isContributorView,
    openReservationModal,
    reservationByCurrentVisitor,
  },
  { isMobile, registry }
) => {
  const {
    id: regItemId,
    url,
    isReserved,
    disableReservations,
    quantity,
    quantityNeeded,
    offers,
  } = regItem

  const regItemLink = (child) => {
    const isReservedByCurrentVisitor = !!reservationByCurrentVisitor

    if (!isContributorView) {
      if (isReserved || isReservedByCurrentVisitor || disableReservations) {
        return (
          <Link className="link-info" url={url} rel="nofollow" newWindow>
            {child}
          </Link>
        )
      }
      return (
        <Link
          className="link-info"
          onClick={openReservationModal}
          rel="nofollow"
        >
          {child}
        </Link>
      )
    }
    // contributor view
    if (isMobile) {
      return <EditRegItemLink regItemId={regItemId}>{child}</EditRegItemLink>
    }
    return (
      <Link url={url} newWindow>
        {child}
      </Link>
    )
  }

  const Wrapper = ({ children }) => {
    if (isMobile && !isContributorView) {
      return <Card>{children}</Card>
    }
    return children
  }

  const actions = () => {
    if (isContributorView) {
      return <OwnerActions showEditAction regItemId={regItemId} />
    }
    if (reservationByCurrentVisitor) {
      return <>Gifted By You</>
    }
    return (
      <AddOrBuy
        regItem={regItem}
        offers={offers}
        registry={registry}
        reservation={reservationByCurrentVisitor}
      />
    )
  }

  return (
    <Wrapper>
      <RegItemCardLayout
        regItem={regItem}
        regItemLinkDecorator={regItemLink}
        quantityInformation={
          <QuantityInformation
            quantity={quantity}
            quantityNeeded={quantityNeeded}
          />
        }
        actions={actions()}
      />
    </Wrapper>
  )
}

FavorRegItemCard.propTypes = {
  regItem: PropTypes.shape(regItemProps).isRequired,
  isContributorView: PropTypes.bool.isRequired,
  reservationByCurrentVisitor: PropTypes.object,
  openReservationModal: PropTypes.func.isRequired,
}

FavorRegItemCard.contextTypes = {
  isMobile: PropTypes.bool,
  registry: PropTypes.bool,
}

FavorRegItemCard.defaultProps = {
  reservationByCurrentVisitor: null,
}
